export interface ClampStylesOptions {
  min: number;
  max: number;
  vMin?: number;
  vMax?: number;
  slopeUnit?: string;
}

/**
 * Converts a px value to rem.
 */
function toRem(value: number) {
  return value / 16;
}

/**
 * Rounds a number to the given decimal places.
 */
function round(value: number, decimals: number) {
  const factor = 10 ** decimals;

  return Math.round(value * factor) / factor;
}

/**
 * Computes the `clamp` value used for responsive sizing.
 */
export function getClampStyles({
  min,
  max,
  vMin = 400,
  vMax = 960,
  slopeUnit = "vw",
}: ClampStylesOptions) {
  const minWidth = toRem(vMin);
  const maxWidth = toRem(vMax);
  const slope = (toRem(max) - toRem(min)) / (maxWidth - minWidth);
  const yAxisIntersection = -minWidth * slope + toRem(min);

  const params = [
    `${toRem(min)}rem`,
    `${round(slope * 100, 4)}${slopeUnit} + ${round(yAxisIntersection, 4)}rem`,
    `${toRem(max)}rem`,
  ];

  return `clamp(${params.join(", ")})`;
}
